import { all } from 'redux-saga/effects'
import { sagas as accountSagas } from './account'
import { sagas as eventSettingSagas } from './eventSetting'

export default function* rootSaga() {
  yield all([...accountSagas, ...eventSettingSagas])
}
